export const OPEN_CONFIGURATION = "OPEN_CONFIGURATION";
export const OPEN_PREVIEW = "OPEN_PREVIEW";
export const CLOSE_CONFIGURATION = "CLOSE_CONFIGURATION";
export const CLOSE_PREVIEW = "CLOSE_PREVIEW";
export const ADD_PARTICIPANT = "ADD_PARTICIPANT";
export const UPDATE_PARTICIPANTS = "UPDATE_PARTICIPANTS";
export const SET_TEMPLATE = "SET_TEMPLATE";
export const RESET_TEMPLATE = "RESET_TEMPLATE";
export const UNRESET = "UNRESET";
export const OPEN_GENERAL = "OPEN_GENERAL";
export const CLOSE_GENERAL = "CLOSE_GENERAL";
export const SET_DOCUMENT = "SET_DOCUMENT";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const SET_STATUS = "SET_STATUS";
export const FILL_MY_DATA = "FILL_MY_DATA";
export const RESET_FILL_MY_DATA = "RESET_FILL_MY_DATA";
export const SET_SHIELD_TYPE = "SET_SHIELD_TYPE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const RESET_DOCUMENT = "RESET_DOCUMENT";
export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
export const SET_DOCUMENT_PARTICIPANTS = "SET_DOCUMENT_PARTICIPANTS";
export const SET_NUM_PAGES = "SET_NUM_PAGES";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_SIGNATURES = "SET_SIGNATURES";
export const UPDATE_SIGNATURE = "UPDATE_SIGNATURE";
export const REMOVE_SIGNATURE = "REMOVE_SIGNATURE";
export const SET_CURRENT_ELEMENT = "SET_CURRENT_ELEMENT";
export const CHANGED_DATA = "CHANGED_DATA";
export const RESTORE_ITEM = "RESTORE_ITEM";
export const SET_LAWYER_NEEDED = "SET_LAWYER_NEEDED";
export const ADD_TO_CART = "ADD_TO_CART";
export const SET_IS_INVOICE_NEEDED = "SET_IS_INVOICE_NEEDED";
export const SET_CHECKOUT_INFO = "SET_CHECKOUT_INFO";
export const RESTORE_DOCUMENT_ITEM = "RESTORE_DOCUMENT_ITEM";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const SET_EDIT_FIELD = "SET_EDIT_FIELD";
export const ADD_NEW_VARIABLE = "ADD_NEW_VARIABLE";
export const DRAG_NEW_VARIABLE = "DRAG_NEW_VARIABLE";
export const SET_SIGNATURE_TYPE = "SET_SIGNATURE_TYPE";
export const SET_JURISDICTION = "SET_JURISDICTION";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_TOTAL_STEPS = "SET_TOTAL_STEPS";
export const SET_PROGRESS = "SET_PROGRESS";
export const SET_AI_DATA = "SET_AI_DATA";
